// Layout Types
import { DefaultLayout } from "./layouts";
import withStorage from "./components/common/WithStorage";
// Route Views
import Cms from "./views/Cms";
import Alerts from "./views/Alerts";
import Faq from "./views/Faq";
import Members from "./views/Members";
import PublicBlog from "./views/PublicBlog";
import Education from "./views/Education";
import FourYear from "./views/FourYear";
import Profile from "./views/Profile";
import PostEditor from "./views/PostEditor";
import Errors from "./views/Errors";
import PostPage from "./views/PostDetail";
import Success from "./views/Success";
import Analyst from "./views/Analyst";
import Analysts from "./views/Analysts";
import SignupLayout from "./layouts/SignupLayout";
import Login from "./views/Login";
import Forgot from "./views/Forgot";
import Register from "./views/Register";
import Prices from "./views/Prices";
import Terms from "./views/Terms";
import Homepage from "./views/Homepage";
import PublicSale from "./views/Sale/PublicSale";
import Policy from "./views/Policy";
import Search from "./views/Search";
import LandingPage from "./views/LandingPage";
import BareLayout from "./layouts/BareLayout";
import NFTPage from "./views/NFTPage";

export default [
  {
    path: "/login",
    layout: BareLayout,
    component: Login,
  },
  {
    path: "/",
    layout: BareLayout,
    component: Homepage,
  },
  {
    path: "/landing-legacy",
    layout: LandingPage,
    component: LandingPage,
  },
  {
    path: "/forgot",
    layout: BareLayout,
    component: Forgot,
  },
  {
    path: "/success",
    layout: SignupLayout,
    component: Success,
  },
  {
    path: "/register",
    layout: BareLayout,
    component: Register,
  },
  {
    path: "/terms&conditions",
    layout: BareLayout,
    component: Terms,
  },
  {
    path: "/sale",
    layout: BareLayout,
    component: PublicSale,
  },
  {
    path: "/policy",
    layout: BareLayout,
    component: Policy,
  },
  {
    path: "/prices",
    layout: SignupLayout,
    component: Prices,
  },
  {
    path: "/couponcheckout",
    layout: SignupLayout,
    component: Prices,
  },
  {
    path: "/blogs/public",
    layout: BareLayout,
    component: PublicBlog,
  },
  {
    path: "/search",
    layout: BareLayout,
    component: withStorage(Search),
  },
  {
    path: "/blogs/premium/",
    layout: BareLayout,
    component: Members,
  },
  {
    path: "/video/:postName",
    layout: BareLayout,
    component: PostPage,
  },
  {
    path: "/blog/:postName",
    layout: BareLayout,
    component: PostPage,
  },
  {
    path: "/blogs/public/:postName",
    layout: BareLayout,
    component: PostPage,
  },
  {
    path: "/analyst/:id",
    layout: BareLayout,
    component: Analyst,
  },
  {
    path: "/analysts",
    layout: BareLayout,
    component: Analysts,
  },
  {
    path: "/education",
    layout: BareLayout,
    component: Education,
  },
  {
    path: "/alerts",
    layout: BareLayout,
    component: Alerts,
  },
  {
    path: "/faq",
    layout: BareLayout,
    component: Faq,
  },
  {
    path: "/4yearcycle",
    layout: BareLayout,
    component: FourYear,
  },
  {
    path: "/alerts/:id",
    layout: BareLayout,
    component: Alerts,
  },
  {
    path: "/user-profile",
    layout: BareLayout,
    component: Profile,
  },
  {
    path: "/user-profile/connectWallet",
    layout: BareLayout,
    component: Profile,
  },
  {
    path: "/cms",
    layout: BareLayout,
    component: Cms,
  },
  {
    path: "/add-new-post",
    layout: BareLayout,
    component: PostEditor,
  },
  {
    path: "/edit-post/:postId",
    layout: BareLayout,
    component: PostEditor,
  },
  {
    path: "/errors",
    layout: DefaultLayout,
    component: Errors,
  },
  {
    path: "/NFT",
    layout: BareLayout,
    component: Register,
  },
];
